<template>
  <b-modal ref="modal" title="Resumo do caixa" header-class="border-bottom-0" no-close-on-backdrop>
    <div class="row">
      <div class="col-md-4">
        <date-input alias="Data inicial" v-model="searchForm.date_start"></date-input>
      </div>
      <div class="col-md-4">
        <date-input alias="Data final" v-model="searchForm.date_end"></date-input>
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <div class="form-group">
          <button type="button" class="btn btn-sm btn-block btn-primary" @click="select">
            <i class="fas fa-search"></i> Filtrar
          </button>
        </div>
      </div>
    </div>
    <hr />
    <h5><i class="fas fa-dollar-sign mr-2"></i>Saldo inicial:</h5>
    <div class="row mb-2">
      <div class="col-6 text-muted">Dinheiro:</div>
      <div class="col-6 text-right">{{ openingBalance() | decimal }}</div>
    </div>
    <hr />

    <h5><i class="fas fa-arrow-up mr-2" style="color: green"></i>Entradas:</h5>

    <div class="row mb-2">
      <div class="col-6 text-muted">Vendas em Dinheiro:</div>
      <div class="col-6 text-right">
        {{ totalCashOrders() | decimal }}
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-muted">Transferência:</div>
      <div class="col-6 text-right">{{ sumByTransferInput() | decimal }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-muted">Recebimento de Contas:</div>
      <div class="col-6 text-right">{{ sumByBillReceived() | decimal }}</div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-muted">Outras Entradas:</div>
      <div class="col-6 text-right">
        {{ sumByCustomTransaction() | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-black">Total de Entradas:</div>
      <div class="col-6 text-right">
        {{ this.sumByInputAccount() | decimal }}
      </div>
    </div>
    <hr />

    <!-- SAIDAS -->
    <h5><i class="fas fa-arrow-down mr-2" style="color: red"></i>Saídas:</h5>

    <div class="row mb-2">
      <div class="col-6 text-muted">Dinheiro:</div>
      <div class="col-6 text-right">
        {{ getsumByPaymentMethodIsOut(1) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-muted">Transferência:</div>
      <div class="col-6 text-right">{{ sumByTransferOutput() | decimal }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-black">Total de Saídas:</div>
      <div class="col-6 text-right">{{ sumByOutputAccount() | decimal }}</div>
    </div>
    <hr />
    <div class="row mb-2">
      <h5 class="col-6 text-black">
        <i class="fas fa-equals mr-2"></i>Resultado do caixa:
      </h5>
      <h5 class="col-6 text-right">{{ sumTotal() | decimal }}</h5>
    </div>
    <hr />

    <h5><i class="far fa-money-bill-alt mr-2"></i>Vendas e Recebimentos</h5>

    <div class="row mb-2">
      <div class="col-6">Dinheiro:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(1) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Cheque:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(2) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Cartão crédito:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(3) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Cartão débito:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(4) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Crediário:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(5) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Boleto Bancário:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(15) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Depósito Bancário:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(16) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Pix:</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(17) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Carteira Digital :</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(18) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Outros :</div>
      <div class="col-6 text-right">
        {{ getSumByPaymentMethod(99) | decimal }}
      </div>
    </div>
    <hr />

    <div class="row mb-2">
      <div class="col-6">Total em Vendas:</div>
      <div class="col-6 text-right">
        <b>{{ orderTotal() | decimal }}</b>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6">Total em Recebimentos:</div>
      <div class="col-6 text-right">
        <b>{{ billReceivedTotal() | decimal }}</b>
      </div>
    </div>

    <div slot="modal-footer">
      <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
        <i class="fas fa-arrow-left"></i> voltar
      </button>
    </div>
  </b-modal>
</template>

<script>
import Filters from "../../../mixins/Filters";
import moment from "moment";

export default {
  data: function () {
    return {
      searchForm: {
        account_id: null,
        date_start: null,
        date_end: null
      },

      sum_transfer_input: [],

      sum_transfer_output: [],

      response: {
        sumByPaymentMethod: {},
        sumByPaymentMethodIsOut: {},
        transfers: {},
        transfersIsOut: {},
        openingBalance: {},
        sumByBillReceived: {},
        sumByCustomTransaction: {},
        orderTotal: {},
        billReceivedTotal: {},
        totalCashOrders: {},
      }
    };
  },

  watch: {
    response(newValue, oldValue) {
      this.response = newValue;
    }
  },

  methods: {
    async open(account_id) {
      this.reset(account_id);

      await this.select();

      // this.requestSelect().then((response) => {
      //   this.response = response.data;

      //   this.sum_transfer_input = response.data.transfers;

      //   this.sum_transfer_output = response.data.transfersIsOut;

      //   this.$refs.modal.show();
      // });
    },

    reset(account_id) {
      this.searchForm.account_id = account_id;
      this.searchForm.date_start = moment().format("YYYY-MM-DD");
      this.searchForm.date_end = moment().format("YYYY-MM-DD");
    },

    getSumByPaymentMethod(paymentMethod) {
      if (!this.response.sumByPaymentMethod[paymentMethod]) {
        return 0;
      }

      return this.response.sumByPaymentMethod[paymentMethod].sum_value;
    },

    getsumByPaymentMethodIsOut(paymentMethod) {
      if (!this.response.sumByPaymentMethodIsOut[paymentMethod]) {
        return 0;
      }

      return this.response.sumByPaymentMethodIsOut[paymentMethod].sum_value;
    },

    openingBalance() {
      return this.response.openingBalance.balance;
    },

    sumByBillReceived() {
      return this.response.sumByBillReceived.sum_bill_value;
    },

    totalCashOrders() {
      return this.response.totalCashOrders.sum_value;
    },

    billReceivedTotal() {

      return this.response.billReceivedTotal.sum_value
    },
    orderTotal() {
      return this.response.orderTotal.sum_value
    },
    sumByCustomTransaction() {
      return this.response.sumByCustomTransaction.sum_custom_transaction_value;
    },

    sumByTransferInput() {
      return this.response.transfers.sum_value;
    },

    sumByTransferOutput() {
      return this.response.transfersIsOut.sum_value;
    },

    select() {
      this.$store.commit("showLoading");

      this.$store
        .dispatch("accountResume/getResume", { params: this.searchForm })
        .then(response => {
          this.response = this.$store.state.accountResume.resume;

          this.sum_transfer_input = this.$store.state.accountResume.resume.transfers;

          this.sum_transfer_output = this.$store.state.accountResume.resume.transfersIsOut;

          this.$store.commit("hideLoading");

          this.$refs.modal.show();
        })
        .catch(error => {
          commit("userHasLoadedWithError", { error: error }, { root: true });
        });
    },

    sumByInputAccount() {
      let billReceived = this.sumByBillReceived();

      let payMethodOne = this.totalCashOrders();

      let transferInput = this.sumByTransferInput();

      let customInput = this.sumByCustomTransaction();

      let somaInput =
        parseFloat(billReceived) +
        parseFloat(payMethodOne) +
        parseFloat(transferInput) +
        parseFloat(customInput);

      return somaInput;
    },

    sumByOutputAccount() {
      let cumstomOut = this.getsumByPaymentMethodIsOut(1);

      let transferOutput = this.sumByTransferOutput();

      let somaOutput = parseFloat(cumstomOut) + parseFloat(transferOutput);

      return somaOutput;
    },

    sumTotal() {
      let input =
        parseFloat(this.sumByInputAccount()) +
        parseFloat(this.openingBalance()) +
        parseFloat(this.sumByOutputAccount());

      return input;
    }
  }
};
</script>

<style></style>
